import React from "react";
import Man from "./../../../assets/instrucctions/Man-Passport.jpg";
import Woman from "./../../../assets/instrucctions/woman-passport.jpg";
import Baby from "./../../../assets/instrucctions/baby-passport.jpg";
import WomanMuslim from "./../../../assets/instrucctions/Woman-muslim-passport.jpg";
import Mockup from "./../../../assets/instrucctions/illust-photo.svg";
import Image from "next/image";
import "./styles.scss";

const PhotoRequirements = () => {
  return (
    <span className="photoRequirements">
      <div className="photoRequirements--item">
        <Image
          src={Man}
          alt="example requirements man"
          width={118}
          height={118}
        />
      </div>
      <div className="photoRequirements--item">
        <Image
          src={Woman}
          alt="example requirements woman"
          width={118}
          height={118}
        />
      </div>
      <div className="photoRequirements--item">
        <Image
          src={WomanMuslim}
          alt="example requirements woman"
          width={118}
          height={118}
        />
      </div>
      <div className="photoRequirements--item">
        <Image
          src={Baby}
          alt="example requirements baby"
          width={118}
          height={118}
        />
      </div>
      <div className="photoRequirements--item">
        <Mockup
          alt="example requirements"
          width={260}
          height={136}
        />
      </div>
    </span>
  );
};

export default PhotoRequirements;
